var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.10761 18.2427L6 29.7291L8.65858 30L9.49818 17.115L7.10761 18.2427Z",
    fill: "url(#paint0_linear_174_8743)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65815 9.95837C9.80066 14.9877 9.96528 18.8606 10.0239 19.9922C9.90382 24.0256 9.71428 25.2775 9.60327 29.8477C9.94183 29.7324 10.193 29.6468 10.5292 29.5323C10.3849 25.5348 10.1579 20.8357 10.0775 19.4576C10.1045 18.7245 10.1314 17.9623 10.1584 17.1034C10.4602 17.2818 10.7925 17.4743 11.0549 17.5641C10.875 14.6088 10.42 10.934 10.3223 10.2065C10.3251 10.0483 10.3279 9.88789 10.3308 9.72463C10.1085 9.80503 9.88437 9.88309 9.65815 9.95837Z",
    fill: "url(#paint1_linear_174_8743)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2915 9.35599C11.4062 14.8258 11.5194 17.2766 11.6326 19.6304C11.5213 23.3125 11.3575 25.2994 11.2498 29.2594C11.6578 29.1088 11.9139 29.0143 12.1912 28.912C12.0717 25.6366 11.825 21.1232 11.7072 19.5832C11.7318 18.9718 11.7654 19.25 11.8026 17.9154C12.1395 18.0903 12.3669 18.2058 12.5638 18.27C12.4161 15.8631 12.0811 11.1311 11.9446 10.2563C11.9513 9.87202 11.9579 9.47763 11.9645 9.07184C11.7426 9.16921 11.5182 9.26396 11.2915 9.35599Z",
    fill: "url(#paint2_linear_174_8743)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9335 8.62234C13.0358 14.7575 13.1369 17.0534 13.2379 19.365C13.1666 20.9604 13.0164 25.0675 12.9258 28.6254C13.2986 28.4876 13.5304 28.396 13.8464 28.2662C13.6831 24.0611 13.5365 22.9274 13.3812 19.6304L13.4686 18.6808C13.6863 18.7513 13.9759 18.8733 14.1794 18.9245C13.9798 15.8356 13.8126 13.0027 13.6176 10.0936C13.6295 9.50779 13.6413 8.89536 13.6527 8.25567C13.4164 8.38113 13.1766 8.50337 12.9335 8.62234Z",
    fill: "url(#paint3_linear_174_8743)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6028 7.72392C14.6841 12.9874 14.7648 18.1432 14.8455 22.044C14.8298 23.7768 14.7857 25.2685 14.6452 27.9668C14.9038 27.8371 15.1514 27.7176 15.3238 27.6278C15.2689 25.8943 15.1766 23.9128 15.0884 22.3041C15.1167 20.4128 15.0616 21.692 15.0953 19.2469C15.2528 19.2967 15.5852 19.4378 15.9001 19.502C15.7632 17.4365 15.4064 10.997 15.2606 9.86601C15.2716 9.00965 15.2823 8.15175 15.2929 7.29986C15.0666 7.44442 14.8366 7.58586 14.6028 7.72392Z",
    fill: "url(#paint4_linear_174_8743)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1833 1.50719C21.3716 11.0539 21.6641 25.4557 21.6814 25.4557C21.787 21.1038 21.8927 7.43471 22.0001 5.72205e-05C21.7599 0.513964 21.4871 1.01685 21.1833 1.50719Z",
    fill: "url(#paint5_linear_174_8743)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5454 3.70316C19.7254 13.8042 20.0064 26.1132 20.0527 26.109C20.145 22.7096 20.2375 11.9764 20.3313 2.745C20.0834 3.07121 19.8212 3.39065 19.5454 3.70316Z",
    fill: "url(#paint6_linear_174_8743)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8997 5.34442C18.034 14.5524 18.1671 23.2677 18.3002 26.6951C18.3176 26.6949 18.5006 14.9207 18.6312 4.6655C18.3951 4.8964 18.151 5.12273 17.8997 5.34442Z",
    fill: "url(#paint7_linear_174_8743)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.252 6.65193C16.4331 16.4753 16.6777 27.2784 16.7075 27.2789C16.7986 24.247 16.888 15.2353 16.9792 6.10813C16.7423 6.29332 16.4998 6.4747 16.252 6.65193Z",
    fill: "url(#paint8_linear_174_8743)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_174_8743",
    x1: 7.3937,
    y1: 28.9363,
    x2: 7.73943,
    y2: 19.0759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00447004,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_174_8743",
    x1: 10.3302,
    y1: 26.6565,
    x2: 10.3273,
    y2: 12.5828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00447004,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_174_8743",
    x1: 11.9604,
    y1: 26.2565,
    x2: 11.8102,
    y2: 13.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00447004,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_174_8743",
    x1: 13.6071,
    y1: 25.5414,
    x2: 13.4184,
    y2: 14.3123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00447004,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_174_8743",
    x1: 14.8666,
    y1: 25.0351,
    x2: 15.0515,
    y2: 14.9475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00447004,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_174_8743",
    x1: 21.7927,
    y1: 21.562,
    x2: 21.7569,
    y2: 14.7395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00447004,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_174_8743",
    x1: 20.0205,
    y1: 22.7309,
    x2: 20.0024,
    y2: 14.8456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00447004,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_174_8743",
    x1: 18.207,
    y1: 23.4061,
    x2: 18.2208,
    y2: 15.3861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00447004,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_174_8743",
    x1: 16.6385,
    y1: 23.9449,
    x2: 16.6325,
    y2: 15.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00447004,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.093494423e77eb56eb610c186e9c572f.svg";
export { ForwardRef as ReactComponent };